<template>
	<div class="page">
		<el-card>
			<div slot="header" class="card-header">
				<span>群聊管理</span>
				<div style="float:right">
					<el-input v-model="keyword" placeholder="群名" style="width:200px" clearable
						@keyup.enter.native="search" @clear="search"></el-input>
					<el-button type="primary" icon="el-icon-search" @click="search" style="margin-left:8px">查询</el-button>
				</div>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column prop="id" label="ID" width="90"></el-table-column>
				<el-table-column label="群头像" width="70">
					<template slot-scope="scope">
						<el-image v-if="scope.row.headImage" :src="scope.row.headImage" style="width:36px;height:36px"
							fit="cover"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="群名称" min-width="160"></el-table-column>
				<el-table-column prop="ownerId" label="群主ID" width="100"></el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.isBanned ? 'info' : 'success'">
							{{ scope.row.isBanned ? '已封禁' : '正常' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createdTime" label="创建时间" min-width="160"></el-table-column>
				<el-table-column label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" plain @click="cleanMsg(scope.row)">清理记录</el-button>
						<el-button size="mini" type="danger" @click="dissolve(scope.row)">解散</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
import AdminApi from '../../api/adminApi.js'

export default {
	data() {
		return {
			loading: false,
			list: [],
			keyword: ''
		}
	},
	created() {
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			new AdminApi().listGroups(this.keyword).then((rows) => {
				this.list = rows || []
			}).catch(() => {}).finally(() => {
				this.loading = false
			})
		},
		search() {
			this.load()
		},
		dissolve(row) {
			this.$confirm('确认解散群聊『' + row.name + '』？群及成员关系将被删除。', '警告', {
				type: 'warning'
			}).then(() => {
				new AdminApi().dissolveGroup(row.id).then(() => {
					this.$message.success('群聊已解散')
					this.load()
				}).catch(() => {})
			}).catch(() => {})
		},
		cleanMsg(row) {
			this.$confirm('确认清理群聊『' + row.name + '』的全部聊天记录？该操作不可恢复,仅清理消息不影响群本身。', '清理聊天记录', {
				type: 'warning',
				confirmButtonText: '确认清理'
			}).then(() => {
				new AdminApi().cleanGroup(row.id).then(() => {
					this.$message.success('群聊天记录已清理')
				}).catch(() => {})
			}).catch(() => {})
		}
	}
}
</script>

<style scoped>
.page {
	padding: 4px;
}

.card-header {
	font-weight: 600;
}
</style>
